import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ROLE_METADATA, UserRole } from '@/components/authnz/types/rbac';
import type { GrantChip, PrototypeRow } from './types';
import { explainAccess } from './fake-store';

export function GrantChips({
  grants,
  onRevokeAdmin,
}: {
  grants: GrantChip[];
  onRevokeAdmin?: (role: UserRole) => void;
}) {
  if (grants.length === 0) {
    return <span className="text-sm text-muted-foreground">No grants</span>;
  }
  return (
    <div className="flex flex-wrap gap-1">
      {grants.map((grant) => (
        <Badge
          key={`${grant.role}-${grant.source}`}
          variant={grant.source === 'subscription' ? 'secondary' : 'outline'}
          className="gap-1"
        >
          {ROLE_METADATA[grant.role].displayName}
          <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
            {grant.source}
          </span>
          {grant.source === 'admin' && onRevokeAdmin ? (
            <button
              type="button"
              className="ml-1 text-muted-foreground hover:text-foreground"
              aria-label={`Revoke ${ROLE_METADATA[grant.role].displayName}`}
              onClick={() => onRevokeAdmin(grant.role)}
            >
              ×
            </button>
          ) : grant.source === 'subscription' ? (
            <span className="sr-only">managed by subscription</span>
          ) : null}
        </Badge>
      ))}
    </div>
  );
}

export function LifecycleBadge({ row }: { row: PrototypeRow }) {
  if (row.lifecycle === 'deleted') {
    return <Badge variant="destructive">deleted</Badge>;
  }
  if (row.invitedNotSignedIn) {
    return <Badge variant="secondary">invited, not yet signed in</Badge>;
  }
  return <Badge variant="outline">existing</Badge>;
}

export function DiagnosticBlock({ row }: { row: PrototypeRow }) {
  return (
    <div className="space-y-2">
      <pre className="overflow-auto rounded-md border border-border bg-muted/40 p-3 text-xs text-foreground">
        {explainAccess(row)}
      </pre>
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={() => navigator.clipboard.writeText(explainAccess(row))}
      >
        Copy diagnostic
      </Button>
    </div>
  );
}
